var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileAttach = function SvgFileAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 0A2.333 2.333 0 0 1 21 2.333v16.334A2.333 2.333 0 0 1 18.667 21H2.333A2.333 2.333 0 0 1 0 18.667V2.333A2.333 2.333 0 0 1 2.333 0h16.334Z",
    fill: "#DA0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.616h-.05v7.717a2.616 2.616 0 1 1-5.233 0V6a1.617 1.617 0 1 1 3.233 0v7a.619.619 0 0 1-.617.616.619.619 0 0 1-.616-.616V6.616h-1.1V13a1.716 1.716 0 1 0 3.433 0V6a2.716 2.716 0 1 0-5.433 0v8.333a3.715 3.715 0 0 0 3.716 3.717 3.715 3.715 0 0 0 3.717-3.717V6.616H13Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  })));
};
export default SvgFileAttach;